import app from 'firebase/app'
import 'firebase/auth'
import firebase from "firebase/app";

const config = {
    apiKey: "AIzaSyAFnD3dL3GdGHGjeOl-KmRyhsNaW6UuFfE",
    // authDomain: "fixel-console.firebaseapp.com",
    authDomain: "auth.fixel.ai",
    // databaseURL: "https://fixel-console.firebaseio.com",
    projectId: "fixel-console",
    storageBucket: "fixel-console.appspot.com",
    messagingSenderId: "334843605615",
    appId: "1:334843605615:web:d4e9fb2a2cb368d200539a"
}

class Firebase {
    constructor() {
        app.initializeApp(config)
        this.auth = app.auth()
    }

    login(email, password) {
        return this.auth.signInWithEmailAndPassword(email, password)
    }

    logout() {
        return this.auth.signOut()
    }

    refreshToken = async () => {
        let res;
        try {
            console.log("Refreshing token");
            res = await firebase.auth().currentUser.getIdToken(true);
        }catch (e){
            console.log("An error has occured while trying to refresh token")
        }

        return res;
    }

    async register(name, email, password) {
        await this.auth.createUserWithEmailAndPassword(email, password)
        await this.auth.currentUser.updateProfile({
            displayName: name
        })

        return this.auth.currentUser;
    }

    isInitialized() {
        return new Promise(resolve => {
            this.auth.onAuthStateChanged(resolve)
        })
    }

    getCurrentUsername() {
        return this.auth.currentUser && this.auth.currentUser.displayName
    }

    getCurrentUserMail() {
        return this.auth.currentUser.email
    }

    connectFacebook = async () => {
        try{
            const facebookAuthProvider = new this.auth.FacebookAuthProvider();
            let fbResult = await this.auth.signInWithPopup(facebookAuthProvider);
            // console.log("🚀 ~ file: firebase.js ~ line 21 ~ connectFacebook ~ fbResult", fbResult)
            // console.log("🚀 ~ file: firebase.js ~ line 21 ~ connectFacebook ~ fbResult.user", fbResult.user)
            // // const token = await firebase.auth().currentUser.getIdToken()
            // let fbUser =  await firebase.auth().currentUser;
            // console.log("🚀 ~ file: firebase.js ~ line 23 ~ connectFacebook ~  fbUser",  fbUser)
            sessionStorage.fbId = fbResult.additionalUserInfo.profile.id;// .providerData.filter(pd=>pd.providerId=='facebook.com')[0].uid
            sessionStorage.fbToken =fbResult.credential.accessToken;// await fbUser.getIdToken();
            return sessionStorage.fbId && sessionStorage.fbToken;
        }catch(err){
            console.error(err.message||err);
            //TODO: add error handling when can't connect FB
        }
    }

    signInWithGoogle = async () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        try {
            const userInfo = await this.auth.signInWithPopup(provider);
            const token = await this.auth.currentUser.getIdToken()
            localStorage.setItem('token',token);
            return userInfo;
        }catch (e){
            console.log(e);
        }
    }

    getUserToken = () => {
        return this.auth.currentUser.getIdToken()
    }

    handleError = (err) => {
        switch (err.code){
            case "auth/user-not-found":
                return "User was not found"
            case "auth/wrong-password":
                return "Wrong Password";
            default:
                return "There was a problem signing you in"
        }
    }

    /**
     *
     * @param event
     * @param email
     * @param password
     * @param onError
     * @returns {Promise<void>}
     */
    signInWithEmailAndPasswordHandler = async (event, email, password, onError) => {
        event.preventDefault();
        return await this.auth.signInWithEmailAndPassword(email, password).catch(error => {
            console.error("Error signing in with password and email", error);
            onError(this.handleError(error));
            setTimeout(()=> {
                onError(null);
            },3000);
        });
    };
}

export default new Firebase();